import React from 'react';
import '../App.css';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';

const Perfil = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <section className="perfil-page">
        <h2>Mi Perfil</h2>
        <div className="perfil-msg">
          Debes iniciar sesión para ver tu perfil.
          <button className="perfil-login-btn" onClick={() => navigate('/login')}>Iniciar sesión</button>
        </div>
      </section>
    );
  }

  return (
    <section className="perfil-page">
      <h2>Mi Perfil</h2>
      <div className="perfil-datos">
        <h3>Datos personales</h3>
        <form className="perfil-form-placeholder">
          <input type="text" placeholder="Nombre completo" value="Julio Pintos" readOnly />
          <input type="email" placeholder="Correo electrónico" value="julio@email.com" readOnly />
          <input type="text" placeholder="Dirección" value="" readOnly />
          <button className="perfil-editar-btn">Editar datos</button>
        </form>
      </div>
      <div className="perfil-historial">
        <h3>Historial de compras</h3>
        <div className="perfil-historial-placeholder">
          <div className="perfil-compra-card">Compra #1 - $0.00 - 01/01/2024</div>
          <div className="perfil-compra-card">Compra #2 - $0.00 - 02/01/2024</div>
        </div>
      </div>
    </section>
  );
};

export default Perfil; 